import {
  alertMessagesArgsConfig,
  browserStorageArgsConfig,
  collectionArgsConfig,
  consoleLogArgsConfig,
  getItemIdFromArgsConfig,
  isNonPersistentArgsConfig,
  collectionFieldArgsConfig,
} from '../../utils/event_constants';

export const mPesaActions = [
  {
    name: 'initiateMPesaC2BPayment',
    label: 'Initiate M-Pesa C2B Payment (STK Push)',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'phoneNumberField', label: 'Select Phone Number Field' }),
      collectionFieldArgsConfig({ name: 'amountField', label: 'Select Amount Field' }),
      {
        name: 'transactionType',
        label: 'Select Transaction Type',
        type: 'dropdown',
        optionsType: 'transactionType',
        options: [
          { label: 'Customer Pay Bill Online', value: 'CustomerPayBillOnline' },
          { label: 'Customer Buy Goods Online', value: 'CustomerBuyGoodsOnline' },
        ],
        value: '',
      },
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({ name: 'mPesaReferenceField', label: 'M-Pesa Reference Field' }),
      ...alertMessagesArgsConfig,
      ...isNonPersistentArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'initiateMPesaB2CPayout',
    label: 'Send M-Pesa B2C Payment',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'phoneNumberField', label: 'Select Phone Number Field' }),
      collectionFieldArgsConfig({ name: 'amountField', label: 'Select Amount Field' }),
      collectionFieldArgsConfig({ name: 'occasionField', label: 'Select Occasion Field' }),
      {
        name: 'transactionType',
        label: 'Select Transaction Type',
        type: 'dropdown',
        optionsType: 'transactionType',
        options: [
          { label: 'Salary Payment', value: 'SalaryPayment' },
          { label: 'Promotion Payment', value: 'PromotionPayment' },
          { label: 'Business Payment', value: 'BusinessPayment' },
        ],
        value: '',
      },
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({ name: 'mPesaReferenceField', label: 'M-Pesa Reference Field' }),
      ...alertMessagesArgsConfig,
      ...isNonPersistentArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'registerMpesaC2BUrls',
    label: 'Register M-Pesa C2B Callback URLs',
    args: [...alertMessagesArgsConfig],
  },
];
